import reduceReducer from "reduce-reducers"
import { createAPIRequestReducer } from "../api"
import ActionTypes from "../../enums/ActionTypes"

const listReducer = createAPIRequestReducer(ActionTypes.LICENCE_MODULES_LIST)
const addReducer = createAPIRequestReducer(ActionTypes.LICENCE_MODULES_ADD)

export default reduceReducer(listReducer, addReducer)
